<template>
  <div>
    <b-modal
      v-model="modalAberto"
      scrollable
      centered
      title="Ações para este usuário"
      header-bg-variant="secondary"
      header-text-variant="light"
      size="xl"
      hide-footer
      @hide="closeModal"
    >
      <b-overlay :show="carregandoModal">
        <div class="container">
          <b-card
            :header="computedTitle"
            header-class="text-center font-weight-bold"
          >
            <b-container fluid>
              <b-row>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">CPF:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.CPF !== ""
                      ? formatarCPF(itemSelecionado.CPF)
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Email:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.EMAIL !== "" ? itemSelecionado.EMAIL : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Telefone:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.TELEFONE !== ""
                      ? itemSelecionado.TELEFONE
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Comunicação:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.FL_COMUNICA_TELEFONE ? "Sim" : "Não"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Situação</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.SITUACAO !== ""
                      ? formatarSituacao(itemSelecionado.SITUACAO)
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Criação:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.DATA_CRIACAO
                      ? formatData(itemSelecionado.DATA_CRIACAO)
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">OAB:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.OAB ?? "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Município:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.CRP_MUNICIPIO?.NM_NOME ?? "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">CEP:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.CEP !== "" ? itemSelecionado.CEP : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Bairro:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.BAIRRO !== ""
                      ? itemSelecionado.BAIRRO
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Logradouro:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.LOGRADOURO !== ""
                      ? itemSelecionado.LOGRADOURO
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Número:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.NUMERO !== ""
                      ? itemSelecionado.NUMERO
                      : "N/A"
                  }}</span>
                </b-col>
                <b-col cols="12" lg="4">
                  <span style="font-weight: bold">Complemento:</span>
                  <span style="margin-left: 5px">{{
                    itemSelecionado.COMPLEMENTO !== ""
                      ? itemSelecionado.COMPLEMENTO
                      : "N/A"
                  }}</span>
                </b-col>
              </b-row>
            </b-container>
            <b-container fluid class="mt-4">
              <b-row class="m-2 d-flex justify-content-center">
                <b-col
                  cols="auto"
                  class="m-1 d-flex align-items-stretch flex-column"
                >
                  <b-button
                    size="sm"
                    @click="abrirModalDocumento('cpf')"
                    class="d-block mb-1"
                    style="margin: 0 auto"
                  >
                    Documento com foto
                    <font-awesome-icon icon="eye" class="ml-1" />
                  </b-button>
                  <VuePdfEmbed
                    v-if="documentos.cpf.filename.endsWith('.pdf')"
                    ref="pdfCpf"
                    class="pdfzin"
                    :source="documentos.cpf.data"
                  />
                </b-col>
                <b-col
                  v-if="possuiDocumentoVerso"
                  cols="auto"
                  class="m-1 d-flex align-items-stretch flex-column"
                >
                  <b-button
                    size="sm"
                    @click="abrirModalDocumento('cpfverso')"
                    class="d-block mb-1"
                    style="margin: 0 auto"
                  >
                    Documento com foto (verso)
                    <font-awesome-icon icon="eye" class="ml-1" />
                  </b-button>
                  <VuePdfEmbed
                    v-if="documentos.cpfverso.filename.endsWith('.pdf')"
                    ref="pdfCpfVerso"
                    class="pdfzin"
                    :source="documentos.cpfverso.data"
                  />
                </b-col>
                <b-col
                  cols="auto"
                  class="m-1 d-flex align-items-stretch flex-column"
                >
                  <b-button
                    size="sm"
                    @click="abrirModalDocumento('residencia')"
                    class="d-block mb-1"
                    style="margin: 0 auto"
                  >
                    Comprovante de residência
                    <font-awesome-icon icon="eye" class="ml-1" />
                  </b-button>
                  <VuePdfEmbed
                    v-if="documentos.residencia.filename.endsWith('.pdf')"
                    ref="pdfResidencia"
                    class="pdfzin"
                    :source="documentos.residencia.data"
                  />
                </b-col>
              </b-row>
            </b-container>
          </b-card>
          <b-card
            header="Ações"
            class="mt-2 text-center"
            v-if="!computedActions"
          >
            <b-container>
              <b-row class="m-2 d-flex justify-content-center">
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    variant="success"
                    :disabled="
                      [
                        'cancelado',
                        'concluido',
                        'pendente dados',
                        'entregue',
                      ].includes(itemSelecionado.SITUACAO)
                    "
                    @click="
                      alertaAprovarSolicitacao(
                        String(itemSelecionado.ID_NOVO_USUARIO)
                      )
                    "
                    >Aprovar usuário
                    <font-awesome-icon icon="user-check" class="ml-1" />
                  </b-button>
                </b-col>
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    @click="openModalEditarUsuario"
                    :disabled="
                      [
                        'cancelado',
                        'concluido',
                        'pendente dados',
                        'entregue',
                      ].includes(itemSelecionado.SITUACAO)
                    "
                  >
                    Editar usuário
                    <font-awesome-icon icon="pen-to-square" class="ml-1" />
                  </b-button>
                </b-col>
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    @click="openModalEditarEmail"
                    :disabled="
                      [
                        'cancelado',
                        'concluido',
                        'pendente validacao',
                        'pendente dados',
                      ].includes(itemSelecionado.SITUACAO)
                    "
                  >
                    Editar email
                    <font-awesome-icon icon="pen-to-square" class="ml-1" />
                  </b-button>
                </b-col>
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    @click="
                      trocarSenha(String(itemSelecionado.ID_NOVO_USUARIO))
                    "
                    :disabled="
                      ['cancelado', 'concluido'].includes(
                        itemSelecionado.SITUACAO
                      )
                    "
                    >Trocar senha
                    <font-awesome-icon icon="key" class="ml-1" />
                  </b-button>
                </b-col>
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    @click="openModalAlteracoes"
                    :disabled="
                      [
                        'cancelado',
                        'concluido',
                        'pendente dados',
                        'entregue',
                      ].includes(itemSelecionado.SITUACAO)
                    "
                  >
                    Solicitar alterações
                    <font-awesome-icon icon="envelope" class="ml-1" />
                  </b-button>
                </b-col>
                <b-col cols="auto" class="m-1">
                  <b-button
                    size="sm"
                    @click="
                      alertaCancelarSolicitacao(
                        String(itemSelecionado.ID_NOVO_USUARIO)
                      )
                    "
                    :disabled="
                      ['cancelado', 'concluido'].includes(
                        itemSelecionado.SITUACAO
                      )
                    "
                    >Cancelar solicitação
                    <font-awesome-icon icon="ban" class="ml-1" />
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </b-card>
        </div>
      </b-overlay>
    </b-modal>

    <modal-pdf
      v-if="exibirModalPdf"
      @fecharModal="exibirModalPdf = false"
      :pdfData="pdfData"
      :filename="filename"
      titulo="Visualizar Documento"
    />
  </div>
</template>

<script lang="ts">
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { store } from "@/store";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import ModalPdf from "@/components/ModalPdf.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
import usuarioService from "@/services/administracao/usuarioService";
import { NovoUsuario } from "@/types/administracao/usuarios/novo-usuario";

@Component({
  components: {
    ModalPdf,
    VuePdfEmbed,
  },
})
export default class ModalNovoUsuario extends mixins(UtilsTS, Vue) {
  @Prop({ required: true }) itemSelecionado!: NovoUsuario;
  @Prop({ required: false }) formatarSituacao!: (situacao: string) => string;

  carregandoModal = false;
  exibirModalPdf = false;
  pdfData: any = null;
  modalAberto = true;
  filename = "";

  documentos: {
    cpf: {
      filename: string;
      data: Uint8Array | Blob | null;
    };
    cpfverso: {
      filename: string;
      data: Uint8Array | Blob | null;
    };
    residencia: {
      filename: string;
      data: Uint8Array | Blob | null;
    };
  } = {
    cpf: {
      filename: "",
      data: null,
    },
    cpfverso: {
      filename: "",
      data: null,
    },
    residencia: {
      filename: "",
      data: null,
    },
  };

  get computedTitle(): string {
    return this.capitalize(this.itemSelecionado.NOME);
  }

  get computedActions(): boolean {
    if (
      this.itemSelecionado.SITUACAO === "cancelado" ||
      this.itemSelecionado.SITUACAO === "concluido"
    )
      return true;
    else return false;
  }

  get possuiDocumentoVerso(): boolean {
    if (!this.itemSelecionado || !this.itemSelecionado.ANEXO) return false;
    return this.itemSelecionado.ANEXO?.some((a) => a.TIPO === "cpfverso");
  }

  get existFrente(): boolean {
    if (!this.itemSelecionado || !this.itemSelecionado.ANEXO) return false;
    return this.itemSelecionado.ANEXO?.some((a) => a.TIPO === "cpf");
  }
  get existVerso(): boolean {
    if (!this.itemSelecionado || !this.itemSelecionado.ANEXO) return false;
    return this.itemSelecionado.ANEXO?.some((a) => a.TIPO === "cpfverso");
  }
  get existRes(): boolean {
    if (!this.itemSelecionado || !this.itemSelecionado.ANEXO) return false;
    return this.itemSelecionado.ANEXO?.some((a) => a.TIPO === "residencia");
  }

  async mounted() {
    if (this.existFrente) this.showPreview("cpf");
    if (this.existVerso) this.showPreview("cpfverso");
    if (this.existRes) this.showPreview("residencia");
  }

  abrirModalDocumento(tipoDoc: string) {
    const documento = this.documentos[tipoDoc];
    if (!documento?.filename || !documento?.data) {
      this.$toast.error("Documento não carregado.");
      return;
    }
    const extensao = documento.filename.split(".").pop()?.toLowerCase();
    if (extensao === "pdf") {
      this.filename = documento.filename;
      this.pdfData = documento.data;
      this.exibirModalPdf = true;
    } else this.download(documento.filename, documento.data);
  }
  async showPreview(tipoDoc: string) {
    try {
      store.blockScreen = true;
      const anexo = this.itemSelecionado.ANEXO?.find((i) => i.TIPO === tipoDoc);
      if (!anexo?.TIPO) {
        console.error(
          "Documento não encontrado",
          tipoDoc,
          this.itemSelecionado
        );
        this.$toast.error("Documento não encontrado");
        return;
      }
      const extensao = anexo.NOME_ANEXO.split(".").pop()?.toLocaleLowerCase();
      const data = await usuarioService.obterAnexoDeNovoUsuario(
        +anexo.ID_ANEXO
      );
      if (extensao === "pdf") {
        this.documentos[tipoDoc].filename = anexo.NOME_ANEXO;
        const arrayBuffer = await data.arrayBuffer();
        this.documentos[tipoDoc].data = new Uint8Array(arrayBuffer);
      } else {
        const type = `image/${extensao}`;
        const blob = new Blob([data], { type });
        this.documentos[tipoDoc] = { filename: anexo.NOME_ANEXO, data: blob };
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  alertaAprovarSolicitacao(id: string) {
    this.$bvModal
      .msgBoxConfirm(`Deseja aprovar a solicitação deste usuário?`, {
        buttonSize: "sm",
        cancelTitle: "Cancelar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        title: "Aprovar solicitação",
      })
      .then((value) => {
        if (value) this.aprovarUsuario(id);
      })
      .catch((err) => {
        console.error(`Erro ao operar o diálogo de alerta`, err);
      });
  }

  async aprovarUsuario(id: string) {
    try {
      this.carregandoModal = true;
      const response = await usuarioService.aprovarNovoUsuario(id);
      this.$toast.success("Usuário aprovado com sucesso!");
      this.closeModal();
      this.$emit("reload");
    } catch (e: any) {
      this.tratarError(e);
      this.$toast.error("Não foi possível aprovar o usuário");
    } finally {
      this.carregandoModal = false;
    }
  }

  async trocarSenha(id: string) {
    try {
      this.carregandoModal = true;
      const response = await usuarioService.trocarSenhaNovoUsuario(id);
      this.$toast.success(
        "Senha alterada com sucesso!\n Um e-mail foi enviado para o usuário com a nova senha."
      );
    } catch (e: any) {
      this.tratarError(e);
      this.$toast.error("Erro ao tentar alterar a senha do usuário");
    } finally {
      this.carregandoModal = false;
    }
  }

  alertaCancelarSolicitacao(id: string) {
    this.$bvModal
      .msgBoxConfirm(`Deseja cancelar a solicitação deste usuário?`, {
        buttonSize: "sm",
        cancelTitle: "Fechar",
        cancelVariant: "outline-secondary",
        centered: true,
        headerBgVariant: "secondary",
        headerTextVariant: "light",
        okTitle: "Confirmar",
        title: "Cancelar solicitação",
      })
      .then((value) => {
        if (value) {
          this.cancelarSolicitacao(id);
        }
      })
      .catch((err) => {
        console.error(`Erro ao operar o diálogo de alerta`, err);
      });
  }

  async cancelarSolicitacao(id: string) {
    try {
      this.carregandoModal = true;
      const response = await usuarioService.cancelarSolicitacaoNovoUsuario(id);
      this.closeModal();
      this.$emit("simplereload");
      this.$toast.success("Solicitação cancelada com sucesso!");
    } catch (e: any) {
      this.tratarError(e);
      this.$toast.error("Erro ao tentar cancelar a solicitação do usuário.");
    } finally {
      this.carregandoModal = false;
    }
  }

  openModalEditarUsuario() {
    this.$emit("editar");
  }

  openModalEditarEmail() {
    this.$emit("editarmail");
  }

  openModalAlteracoes() {
    this.$emit("alterar");
  }

  closeModal() {
    this.$emit("close");
  }
}
</script>

<style>
.pdfzin {
  box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.7);
}
</style>
